import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../../global/globals';

export interface DisplayType {
  id?: number;
  name: string;
  code: string;
}

@Injectable({ providedIn: 'root' })
export class DisplayTypeService {
  private baseUrl: string;

  constructor(private http: HttpClient, private globals: Globals) {
    this.baseUrl = this.globals.backendUri + '/display-type';
  }

  getAll(): Observable<DisplayType[]> {
    return this.http.get<DisplayType[]>(this.baseUrl);
  }

  getById(id: number): Observable<DisplayType> {
    return this.http.get<DisplayType>(`${this.baseUrl}/${id}`);
  }

  create(displayType: DisplayType): Observable<DisplayType> {
    return this.http.post<DisplayType>(this.baseUrl, displayType);
  }

  update(id: number, displayType: DisplayType): Observable<DisplayType> {
    return this.http.put<DisplayType>(`${this.baseUrl}/${id}`, displayType);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
